// SPDX-License-Identifier: AGPL-3.0-or-later
import styles from '@app/features/game_activity/components/GameActivityRowStatus.module.css';
import {useGameActivityIcon} from '@app/features/game_activity/hooks/useGameActivityIcon';
import type {GameActivity} from '@app/features/gateway/types/GatewayPresenceTypes';
import {GameControllerIcon} from '@phosphor-icons/react';
import {clsx} from 'clsx';

export function GameActivityRowStatus({activity, className}: {activity: GameActivity; className?: string}) {
	const {label, iconUrl} = useGameActivityIcon(activity);
	return (
		<div className={clsx(styles.root, className)} role="img" aria-label={label} data-flx="game-activity.row-status">
			{iconUrl ? (
				<img
					className={styles.icon}
					src={iconUrl}
					alt=""
					width={14}
					height={14}
					data-flx="game-activity.game-activity-row-status.icon"
				/>
			) : (
				<GameControllerIcon
					className={styles.icon}
					aria-hidden
					data-flx="game-activity.game-activity-row-status.icon--2"
				/>
			)}
			<span className={styles.name} data-flx="game-activity.game-activity-row-status.name">
				{label}
			</span>
		</div>
	);
}
